import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import { getBannerList } from "../../../api/services";

const HeroSection = () => {
  const [propertyData, setPropertyData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchBanner();
  }, []);

  const fetchBanner = async () => {
    try {
      setLoading(true);
      const res = await getBannerList();
      setPropertyData(res?.data?.data || []);
    } catch (error) {
      console.error("Error fetching banner:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="hero__banner__wrapper"
      id="hero__banner"
      style={{ position: "relative", padding: "10px" }}
    >
      {loading ? (
        <Skeleton height={420} width="100%" />
      ) : (
        <>
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            style={{ borderRadius: "8px" }}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            navigation={{
              nextEl: ".image-swiper-button-next",
              prevEl: ".image-swiper-button-prev",
            }}
            modules={[Navigation, Autoplay]}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
            }}
          >
            {propertyData.map((item) => (
              <SwiperSlide key={item.id}>
                <Link to="#">
                  <div
                    className="bg"
                    style={{
                      backgroundImage: `url(${item.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      height: "420px",
                      width: "100%",
                    }}
                  ></div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
          <div
            className={`image-swiper-button-prev`}
            style={{
              position: "absolute",
              top: "50%",
              left: "15px",
              transform: "translateY(-50%)",
              zIndex: 10,
              background: "#fff",
              padding: "8px",
              borderRadius: "50%",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <GoChevronLeft size={20} />
          </div>

          <div
            className={`image-swiper-button-next`}
            style={{
              position: "absolute",
              top: "50%",
              right: "15px",
              transform: "translateY(-50%)",
              zIndex: 10,
              background: "#fff",
              padding: "8px",
              borderRadius: "50%",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <GoChevronRight size={20} />
          </div>
        </>
      )}
    </div>
  );
};

export default HeroSection;
